var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.5a5.25 5.25 0 0 1 5.246 5.034l.004.216v.75a1 1 0 0 1-1.993.117L19 20.5v-.75a3.25 3.25 0 0 0-3.066-3.245l-.184-.005h-7.5a3.25 3.25 0 0 0-3.245 3.066L5 19.75v.75a1 1 0 0 1-1.993.117L3 20.5v-.75a5.25 5.25 0 0 1 5.034-5.246l.216-.004h7.5zM12 2.5a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUser);
export default __webpack_public_path__ + "static/media/icons-user.27cf5cf3e5d9d50dd9b88357d4fee0c8.svg";
export { ForwardRef as ReactComponent };